import { createFileRoute } from "@tanstack/react-router";
import { PricingPage } from "../../components/pricing/PricingPage.js";

/**
 * Phase 14b — anonymous-accessible `/pricing` route.
 *
 * Path: `/pricing`. Renders the MVP §4.9 canonical pricing copy
 * standalone for the marketing-landing → in-app handoff per `MVP.md`
 * §6 item 7 ("Pricing page in the app reflects Marketing §4").
 *
 * The route is reachable **without authentication** — there are no
 * `<SignedIn>` / `<SignedOut>` wrappers. A prospective user
 * arriving from the marketing site, a signed-out user clicking the
 * Upgrade affordance, and a signed-in user navigating here directly
 * all see the same content. This mirrors the Phase 13h share-link
 * landing's anonymous-accessibility pattern.
 *
 * The route is a thin mount over the pure-presentation `PricingPage`
 * component (`components/pricing/PricingPage.tsx`), keeping the
 * route file free of layout / styling decisions. Tests cover the
 * component directly; the route file's only job is the path binding.
 */
export const Route = createFileRoute("/pricing")({
  component: PricingPage,
});
